import React from 'react';
import { TranslationProps, WithCoreProps } from 'ff-shared-components-core';
import './fieldsFormContainer.less';

export interface FieldsFormContainerProps {
	className?: string;
}

export type FieldsFormContainerInjectedProps = TranslationProps & FieldsFormContainerProps;

class FieldsFormContainerComponent extends React.Component<FieldsFormContainerProps> {
	render(): React.ReactNode {
		const { children, className } = this.props;

		const cssClass = `field-form-container${className ? ` ${className.trim()}` : ''}`;

		return <div className={cssClass}>{children}</div>;
	}
}

export const FieldsFormContainer = WithCoreProps<FieldsFormContainerProps>(FieldsFormContainerComponent);
